import { __makeTemplateObject } from 'tslib';
import React__default, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';

var FullPageOverlay = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Overlay__FullPageOverlay",
  componentId: "sc-x77ci1-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.5);\n  justify-content: center;\n  align-items: flex-start;\n  transition: opacity ", "ms linear;\n"], ["\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.5);\n  justify-content: center;\n  align-items: flex-start;\n  transition: opacity ", "ms linear;\n"])), function (_a) {
  var animationDuration = _a.animationDuration;
  return animationDuration;
});
var Overlay = function (_a) {
  var _b = _a.visible,
    visible = _b === void 0 ? false : _b,
    _c = _a.animationDuration,
    animationDuration = _c === void 0 ? 200 : _c,
    onClick = _a.onClick;
  var zIndexRef = useRef(0);
  var _d = useState(-1),
    zIndex = _d[0],
    setZIndex = _d[1];
  var onVisibleChange = function () {
    if (visible) {
      return setZIndex(99);
    }
    window.clearTimeout(zIndexRef.current);
    zIndexRef.current = window.setTimeout(function () {
      setZIndex(-1);
    }, animationDuration);
  };
  useEffect(function () {
    onVisibleChange();
  }, [visible]);
  return React__default.createElement(FullPageOverlay, {
    zIndex: zIndex,
    opacity: visible ? 1 : 0,
    onClick: onClick,
    animationDuration: animationDuration
  });
};
var templateObject_1;

export { FullPageOverlay, Overlay };
//# sourceMappingURL=Overlay.js.map
